import { downloadBlob } from '@racemap/utilities/functions/download';
import { currentAPIColors } from '../consts';
import { chartTheme, GC_H } from './layout';

// The download is always in day colours, so it reads on white or transparent backgrounds.
// Order matters: the night noDataFill is a prefix of the night axisStroke.
const NIGHT_TO_DAY: Array<[string, string]> = [
  ...(['axisStroke', 'labelFill', 'noDataFill', 'tickStroke'] as const).map(
    (key): [string, string] => [chartTheme(false)[key], chartTheme(true)[key]],
  ),
  [currentAPIColors(false).helperLine, currentAPIColors(true).helperLine],
];

export function downloadChartSvg(svg: SVGSVGElement, width: number, eventName?: string): void {
  const clone = svg.cloneNode(true) as SVGSVGElement;
  clone.setAttribute('width', String(width * 2));
  clone.setAttribute('height', String(GC_H * 2));
  clone.style.cssText = '';
  clone.querySelector(`rect[width="${width}"][height="${GC_H}"]`)?.remove();
  let xml = new XMLSerializer().serializeToString(clone);
  for (const [night, day] of NIGHT_TO_DAY) xml = xml.replaceAll(night, day);
  const svgString = `<?xml version="1.0" encoding="utf-8"?>\n${xml}`;
  const blob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
  const safeName = eventName
    ? `gap-chart-${eventName
        .replace(/[/\\:*?"<>|]+/g, '_')
        .replace(/_+/g, '_')
        .trim()}.svg`
    : 'gap-chart.svg';
  downloadBlob(blob, safeName);
}
